import React, { useEffect, useState, useMemo } from "react";
import { Table, Input, Tooltip, Row, notification, Select } from 'antd';
import { ReactComponent as Icon } from "../../assets/images/info-circle.svg";
import { ProductVariantDisplayType, saleBadgeFour, saleBadgeThree, Units } from "../../pages/constant/Constants";
import Promotions from "../common/Promotions";
import PromotionsPrice from "../common/PromotionPrice";
import PromotionsQTY from "../common/PromotionQTY";
import { isProductTobaccoEligible, getImagesForImageDisplay, refModal } from "../../pages/constant/utils";


const GridViewVariant = ({
    variant_attribute,
    userDetail,
    currency,
    product,
    settingData,
    themeSettingData,
    setQuantityCountObj,
    quantityCountObj,
    setSelectedVariant,
    selectedVariant,
    userData,
    modalRef,
    licensePath
}) => {
    let attributes = []
    const minBackOrderQty = 5
    const [listProducts, setListProducts] = useState([])
    const [selectOptionsGrid, setSelectedOptionsGrid] = useState([])
    const [optionOfGridValue, setOptionOfGridValue] = useState(product.product_variant_attribute.find(({ display_type }) => display_type == 6))

    const findCombinationsForList = ({
        data,
        values,
    }) => {
        const lowerCaseCriteria = Object.entries({
            ...values,
        }).reduce((acc, [key, value]) => {
            acc[key.toLowerCase()] = value.toString().toLowerCase();
            return acc;
        }, {});

        return data.filter((item) => {
            return Object.entries(lowerCaseCriteria).every(([key, value]) => {
                return item.product_variant_attribute.some((attribute) => {
                    return (
                        attribute.ecom_name.toLowerCase() === key &&
                        attribute.value.toString().toLowerCase() === value
                    );
                });
            });
        });
    };

    const handleChange = (id, value, saleable_qty) => {
        setQuantityCountObj((prev) => {
            let temp = value;
            if (temp == null) {
                delete prev[id]
                return { ...prev };
            }
            if (value >= saleable_qty) {
                temp = value;
            }
            return { ...prev, [id]: temp };
        });
    };
    useEffect(() => {
        attributes = attributeFun(product)
        setSelectedOptionsGrid(product.product_variant_attribute.filter(att => att.display_type != ProductVariantDisplayType.GRID_VIEW.type).map(({ name, value, ecom_name }) => ({ name, value, ecom_name })))
    }, [])
    let tempProducts = product.variant_product;
    tempProducts = [{ ...product, variant_product: null }, ...tempProducts];
    useEffect(() => {
        try {
            const availableCombination = findCombinationsForList({ data: tempProducts, values: { [variant_attribute.name]: optionOfGridValue.value } })
            setListProducts(availableCombination)
        }
        catch (error) {
            console.error(error)
        }
    }, [product, optionOfGridValue.value])

    const attributeFun = (product) => {
        const result = {}
        product.variant_attributes.forEach((item) => {
            const { ecom_name, value, display_type, attachment, attachment_name } = item;
            if (!result[ecom_name]) {
                result[ecom_name] = {
                    name: ecom_name,
                    value: [],
                    display_type,
                    attachment,
                    attachment_name
                };
            }
            if (!result[ecom_name].value.includes(value)) {
                result[ecom_name].value.push(value);
            }
        });
        let tempResult = Object.values(result);
        tempResult = tempResult.sort((a, b) => a.display_type - b.display_type);
        const displayTypes = new Set();
        const uniqueTempResult = tempResult.filter(item => {
            if (displayTypes.has(item.display_type)) {
                return false;
            }
            displayTypes.add(item.display_type);
            return true;
        });

        return uniqueTempResult;
    };

    return (
        <div className="frame-wrapper">
            <div className="div-10">
                <div className="text-end">
                    {variant_attribute?.attachment ?
                        <a href={variant_attribute.attachment} target="_blank">
                            <img src={process.env.PUBLIC_URL + "/media/icons/size_guide_img.png"} className="icon" alt="" />
                            <label className="label">
                                {variant_attribute?.attachment_name}
                            </label>
                        </a>
                        : null
                    }
                </div>
                <div>
                    <div className="flex-container">
                        <div className="flex-column">
                            <div className="flex-row">
                                <div className="product-option">{variant_attribute.name}</div>
                                {listProducts.map((product) => {
                                    const nonGridViewAttributes = product.product_variant_attribute
                                        .filter((att) => att.display_type !== ProductVariantDisplayType.GRID_VIEW.type);

                                    const gridViewAttributes = product.product_variant_attribute
                                        .filter((att) => att.display_type === ProductVariantDisplayType.GRID_VIEW.type);

                                    return (
                                        <div className="common-style" key={product.id}>
                                            {nonGridViewAttributes.length > 0 ? (
                                                <div key={product.id}>
                                                    {product.product_variant_attribute
                                                        .filter((option) =>
                                                            !variant_attribute?.value.some((attribute) => attribute === option.value) // Hide if matches any attribute
                                                        )
                                                        .sort((a, b) => a.display_type - b.display_type)
                                                        .map((option) => option.value)
                                                        .join('/')}
                                                </div>
                                            ) : gridViewAttributes.length > 0 ? (
                                                gridViewAttributes
                                                    .filter((option) =>
                                                        !variant_attribute?.value.some((attribute) => attribute === option.value) // Hide if matches any attribute
                                                    )
                                                    .map((option) => option.value)
                                                    .join('/')
                                            ) : (
                                                "Details"
                                            )}
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="flex-column">
                                {variant_attribute?.value.map((attribute, index) => {
                                    const combinations = findCombinationsForList({ data: tempProducts, values: { [variant_attribute.name]: attribute } });
                                    if (combinations.length === 0) return null;
                                    return (
                                        <div className="flex-row" key={index}>
                                            <div className="common-style-sidebar">{attribute}</div>
                                            <div className="flex-row">
                                                {combinations.map((product, index) => (
                                                    <div
                                                        key={index}
                                                        className={
                                                            selectedVariant?.id == product.id
                                                                ? "clicked-style clicked-common-style"
                                                                : "clicked-common-style"
                                                        } onClick={() => setSelectedVariant(product)}
                                                    >
                                                        <div className="flex-column" >
                                                            <div style={{ display: "flex", justifyContent: "space-between", maxHeight: "50px" }}>
                                                                <div className="variant-list-price-grid">
                                                                    {(!userDetail?.user &&
                                                                        themeSettingData?.price_display_for_unsecure_user) ||
                                                                        (userDetail?.user &&
                                                                            themeSettingData?.price_display_for_secure_user) ? (
                                                                        <div>
                                                                            <PromotionsPrice product={product} regularprice={true} currency={currency.currency_symbol} />
                                                                            {product?.is_tax_inclusive &&
                                                                                <p className="tax-inclusive">Tax Inclusive</p>
                                                                            }
                                                                        </div>
                                                                    ) : null}
                                                                </div>
                                                                <Promotions
                                                                    product={product}
                                                                    classMain="promotion-grid"
                                                                    classText={
                                                                        product?.selected_unit_price?.promotion?.sale_badge_template === saleBadgeFour
                                                                            ? "promotion-grid-text-four"
                                                                            : product?.selected_unit_price?.promotion?.sale_badge_template === saleBadgeThree
                                                                                ? "promotion-grid-text-three"
                                                                                : "promotion-grid-text-other"
                                                                    }
                                                                />

                                                            </div>
                                                            <div style={{ display: "flex" }}>
                                                                {(!userDetail?.user &&
                                                                    themeSettingData?.stock_display_for_unsecure_user) ||
                                                                    (userDetail?.user &&
                                                                        themeSettingData?.stock_display_for_secure_user) ? (
                                                                    <>
                                                                        <span className={`stock-status ${product?.back_order_ecom && product?.saleable_qty <= minBackOrderQty ? "low-stock" : product?.saleable_qty <= 0 ? "grid-outof-stock" : "in-stock"}`}>
                                                                            {product?.back_order_ecom && product?.saleable_qty <= minBackOrderQty ? "Low Stock" : product?.saleable_qty <= 0 ? "Out of Stock" : `${product?.saleable_qty || 0} in Stock`}
                                                                        </span>
                                                                    </>
                                                                ) : null}
                                                                {(product?.certificate_of_analysis) && (
                                                                    <p className="coa-style-grid"
                                                                        onClick={() => {
                                                                            const url = product.certificate_of_analysis
                                                                            if (url) {
                                                                                window.open(url, '_blank');
                                                                            } else {
                                                                                console.error('Certificate of Analysis not available.');
                                                                            }
                                                                        }}
                                                                    >
                                                                        Specs & COA
                                                                    </p>
                                                                )}
                                                            </div>
                                                            <div className="flex-row">
                                                                <div>
                                                                    <Input
                                                                        placeholder="Enter Qty"
                                                                        type="number"
                                                                        inputMode="numeric"
                                                                        style={{ backgroundColor: "white" }}
                                                                        disabled={!product?.back_order_ecom && product?.saleable_qty === 0}
                                                                        value={quantityCountObj?.[product?.id] || ''}
                                                                        onChange={(e) => {
                                                                            if (
                                                                                isProductTobaccoEligible(product, userData, settingData)
                                                                            ) {
                                                                                const { value } = e.target;
                                                                                // If the input is empty, handle it separately
                                                                                if (value === '') {
                                                                                    handleChange(product.id, null, product?.saleable_qty ?? 0);
                                                                                    return;
                                                                                }

                                                                                // Parse and validate the input value
                                                                                const quantity = Math.abs(Math.floor(value));
                                                                                const _saleable = product?.saleable_qty ?? 0;

                                                                                // Restrict quantity if exceeds saleable quantity
                                                                                if (!product.back_order_ecom && quantity > _saleable) {
                                                                                    notification.error({
                                                                                        message: "You cannot add more than the in-stock quantity",
                                                                                    });
                                                                                    return;
                                                                                }

                                                                                // Handle valid quantity change
                                                                                handleChange(product.id, quantity, _saleable);
                                                                            } else {
                                                                                refModal(modalRef, licensePath);
                                                                            }
                                                                        }}
                                                                    />

                                                                </div>
                                                                <div className="flex-row" style={{ justifyContent: "end" }}>
                                                                    <Tooltip
                                                                        title={
                                                                            <span>
                                                                                <h1 className="grid-product-name">{product.name}</h1>
                                                                            </span>
                                                                        }
                                                                        overlayClassName="custom-tooltip"
                                                                    >
                                                                        <span className="info-grid">
                                                                            <Icon />
                                                                        </span>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                            <div >
                                                                <PromotionsQTY selectedVariant={product} className={"promotion-qty-grid"} />
                                                            </div>
                                                            {(themeSettingData?.sku_display_on_product_detail || themeSettingData?.upc_display_on_product_detail) && (
                                                                <span className="sku-upc">
                                                                    {themeSettingData?.sku_display_on_product_detail && product?.sku && themeSettingData?.upc_display_on_product_detail && (product.selected_unit_price?.upc || product?.upc)
                                                                        ? `${product.sku}  ${!product.selected_unit_price?.upc ? "" : `/ ${product.selected_unit_price?.upc}`}`
                                                                        : themeSettingData?.sku_display_on_product_detail && product?.sku
                                                                            ? product.sku
                                                                            : themeSettingData?.upc_display_on_product_detail && (!product.selected_unit_price?.upc ? "" : product.selected_unit_price.upc)
                                                                                ? product.selected_unit_price?.upc
                                                                                : ''
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default GridViewVariant;